import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import * as _ from 'lodash';
import Quota from "./Quota";
import Tabulation from "./Tabulation";
import agent from './agent'
import styled from 'styled-components'
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import NotFound from "./NotFound";
import CircularProgress from "@material-ui/core/CircularProgress";

const Page = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const StyledRoot = styled(Page)`
  background-color: #E1E7E9;
`;

const LockComponent = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: 25%;
  align-items: center;
  padding-bottom: 11vh;
  background-color: white;
  padding-top: 11vh;
  & .icon {
    font-size: 5rem;
  }
  & .error {
    color: red;
  }
`;
const StyledMessage = styled.div`
  margin-top: 11vh;
`;
const StyledInputField = styled.input`
   background: #FFFFFF 0% 0% no-repeat padding-box;
   margin-top: 1rem;
   border: 1px solid #707070;
   border-radius: 2px;
   width: 14rem;
   height: 2rem;
   padding-left: 0.7rem;
`;
const StyledButton = styled(Button)`
  width: 10rem;
`;
const StyledContainer = styled.div`
   display: flex;
   flex-direction: column;
   height: 100vh;
   background-color: white;
   & header {
      background-color: #0D5B83;
      color: white;
      display: flex;
      align-items: center;
      box-shadow: 0px 3px 6px #00000029;
      font: Regular 20px/23px Arial;
      height: 3rem;
      line-height: 3rem;
      padding-left: 1rem;
      padding-right: 1rem;
   }
   & main {
       display: flex;
       flex: 1;
       aside {
           background-color: #E1E7E9;
           border-right: 1px solid #C4C4C4;
           display: flex;
           flex-direction: column;
           width: 180px !important;
       }
   }
`;

function useQuery() {
   return new URLSearchParams(useLocation().search);
}

function Detail(props) {
   const [password, setPassword] = useState('');
   const [status, setStatus] = useState(0);
   const [quota, setQuota] = useState([]);
   const [surveys, setSurveys] = useState([]);
   const [type, setType] = useState('quota');
   const [name, setName] = useState('');
   const [updatedAt, setUpdatedAt] = useState('');
   const [gtIndex, setGtIndex] = useState(-1);
   let uuid = props.match.params.id;
   const showProject = () => {
      agent.projects.show(uuid).then(data => {
         setStatus(data.status);
         if (data.status === 200) {
            setQuota(data.quota ? data.quota : []);
            setSurveys(data.surveys);
            setName(data.jobName);
            setUpdatedAt(data.updatedAt);
            if (data.quota.length === 0
                  && _.filter(data.surveys, function(s) { return (('all_answer_count' in s) && s.all_answer_count >= 0); }).length === 0) {
               setTimeout(() => {
                  document.getElementById("gt-item-0").click()
                  // setType('gt');
                  // setGtIndex(0);
               }, 200)
             }
         }
      })
   };

   useEffect(() => {
      showProject();
   }, []);

   return (
      <StyledRoot>
         <ComponentWithRegex
            path={props.location.pathname}
            {...{
               type,
               setType,
               password,
               setPassword,
               status,
               name,
               showProject,
               quota,
               surveys,
               gtIndex, setGtIndex,
               updatedAt
            }}/>
      </StyledRoot>
   )
}


function ComponentWithRegex(props) {
   const {t, i18n} = useTranslation();
   const {gtIndex, setGtIndex} = props;
   if (props.status === 0) {
      return <CircularProgress style={{alignSelf: 'center'}} />;
   }
   let lockComponent = <LockComponent>
      <img src='/logo.png'/>
      <StyledMessage>
         {props.status === 424 ? <span className="error">{t('error_password')}</span>
            : <span>{t('prompt_password')}</span>}
      </StyledMessage>

      <StyledInputField margin="normal" onChange={e => props.setPassword(e.target.value)}/>

   </LockComponent>;
   if (false && !props.unlocked) {
      return lockComponent
   } else {
      if (props.status === 404) {
         return <NotFound/>
      }
      let gts = _.filter(props.surveys, function (s) {
         return s.answers;
      });

      let gtComponent = <div/>;
      let quotaComponent = <div/>;
      let count = _.filter(props.surveys, function(s) { return (('all_answer_count' in s) && s.all_answer_count >= 0) }).length;
      if (gts.length > 0) {
         gtComponent = <div>
            <ListItem>
               {t('title_gt')}
            </ListItem>
            {gts.map((s, index) => <ListItem id={"gt-item-"+index} button key={index} style={{paddingLeft: 30}}
                                             selected={gtIndex === index} onClick={() => {
               props.setType('gt');
               setGtIndex(index);
            }}>
               <div>
                  {t('label_gt').replace('{id}', _.indexOf(props.surveys, s) + 1)}
               </div>
            </ListItem>)}
         </div>
      }

      if (props.quota.length > 0 || count > 0) {
         quotaComponent = <ListItem button selected={props.type === 'quota'} onClick={() => {
            props.setType('quota');
            setGtIndex(-1);
         }}>
            <div>{i18n.t('title_quota')}</div>
         </ListItem>
      }

      let bodyContent = props.type === 'quota' ?
         <Quota quota={props.quota} surveys={props.surveys} updatedAt={props.updatedAt}/>
         : <Tabulation survey={gts[gtIndex]} updatedAt={props.updatedAt}/>;
      return (
         <StyledContainer>
            <header>
               <Grid justify='space-between' container>
                  <div>
                     {t('title')}
                     {props.name}
                  </div>
                  <div>
                     <span style={{cursor: 'pointer'}}
                           onClick={() => i18n.changeLanguage('ja')}>日本語</span>
                     <span style={{margin: '0 0.2rem'}}>/</span>
                     <span style={{cursor: 'pointer'}}
                           onClick={() => i18n.changeLanguage('en')}>English</span>
                  </div>
               </Grid>
            </header>
            <main>
               <aside>
                  <List>
                     {quotaComponent}
                     {gtComponent}
                  </List>
               </aside>
               <div style={{flex: 1}}>
                  {bodyContent}
               </div>
            </main>
         </StyledContainer>
      );
   }
}


export default Detail